import { render, staticRenderFns } from "./PoDetailsHeader.vue?vue&type=template&id=1c2fbdbb&scoped=true"
import script from "./PoDetailsHeader.vue?vue&type=script&lang=ts"
export * from "./PoDetailsHeader.vue?vue&type=script&lang=ts"
import style0 from "./PoDetailsHeader.vue?vue&type=style&index=0&id=1c2fbdbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2fbdbb",
  null
  
)

export default component.exports